export function updateActiveNavItem(path: string): void {
	const normalizedPath = path.startsWith('/setting/')
		? '/settings'
		: normalizeNavPath(path).split('/').slice(0, 2).join('/')
	const navList = document.querySelector<HTMLElement>('.nav-list')
	if (!navList) return

	const navLinks =
		navList.querySelectorAll<HTMLAnchorElement>('a[data-route]')

	navLinks.forEach((link) => {
		const routePath = normalizeNavPath(link.dataset.route ?? '')
		const isActive = routePath === normalizedPath

		link.classList.toggle('is-active', isActive)

		if (!isActive) return

		const item = link.closest<HTMLElement>('.nav-list-item')
		const paddingLeft = Number.parseFloat(
			window.getComputedStyle(navList).paddingLeft,
		)
		const offset = item ? item.offsetLeft - paddingLeft : 0
		navList.style.setProperty('--active-offset', `${offset}px`)
	})
}

function normalizeNavPath(path: string): string {
	return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path
}
